import { render, staticRenderFns } from "./createnewUserPromo.vue?vue&type=template&id=607745ea&"
import script from "./createnewUserPromo.vue?vue&type=script&lang=js&"
export * from "./createnewUserPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports